import { useState } from "react";
import { Link2, Check } from "lucide-react";

export const CopyLinkButton = ({ url, label = "Copy case link", testid = "copy-link-button" }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    const link = url || window.location.href;
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2200);
    } catch (e) {
      // Fallback for older browsers
      const ta = document.createElement("textarea");
      ta.value = link;
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand("copy");
        setCopied(true);
        setTimeout(() => setCopied(false), 2200);
      } catch (err) {
        /* noop */
      }
      document.body.removeChild(ta);
    }
  };

  return (
    <button type="button" onClick={handleCopy} className="ic-btn" data-testid={testid} aria-live="polite">
      {copied ? <Check size={16} /> : <Link2 size={16} />}
      {copied ? "Link copied" : label}
    </button>
  );
};
